import { css, cx } from '@emotion/css';
import { isActive, navItemLink } from 'Shared/frontend/nav/MobileFooterNav';
import { theme } from 'Shared/frontend/SettingsProvider';
import { For } from 'solid-js';



export function SubNav(P)
{
	const buttonStyle = css({
		...theme().nav.desktop.settings.button,
		':hover': theme().nav.desktop.settings.hover
	});

	const subNavStyle = css({
		position: 'absolute',
		left: 0,
		right: 0,
		display: 'none',
	});

	const subNavInnerStyle = css(theme().nav.desktop.settings.subNav,{
		marginTop: '1em',
		padding: '1.5em',
		display: 'flex',
		flexDirection: 'row',
		gap: '1em',
		justifyContent: 'center'
	});

	return (
		<div class={cx(subNavStyle,'subnav')}>
			<div class={subNavInnerStyle}>
				<For each={P.item.items}>{ item => <>
					<a href={navItemLink(item)}>
						<button tabindex='-1'
							classList={{
								[buttonStyle]: true,
								'nav-button': true,
								active: isActive(item),
								[css(theme().nav.desktop.settings.active)]: isActive(item)
							}}
						>
							{item.label}
						</button>
					</a>
				</>}</For>
			</div>
		</div>
	);
}

